module.exports = __webpack_public_path__ + "ea8a8fc21612c414c9162c1720a243a2.svg";